import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type { ConfigurationPersona } from '../../uiModels/types'

export const useConfigurationPersonaName = () => {
  const translate = useTranslate()
  return useMemo(
    () =>
      ({
        ConfigurationViewer: {
          name: translate('personaSelector.option.viewer.name'),
          description: translate('personaSelector.option.viewer.description'),
        },
        ConfigurationEditor: {
          name: translate('personaSelector.option.editor.name'),
          description: translate('personaSelector.option.editor.description'),
        },
        ConfigurationAdmin: {
          name: translate('personaSelector.option.admin.name'),
          description: translate('personaSelector.option.admin.description'),
        },
      }) satisfies Record<
        ConfigurationPersona,
        { name: string; description: string }
      >,
    [translate],
  )
}
